import { ReactNode } from 'react';
import { Tooltip } from '@arkestro/arkestro-design-system';

import styles from './hint.module.scss';

interface HintProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  title?: ReactNode;
}

// Label that carries context on hover. The underline is a visual affordance for the tooltip;
// the tooltip payload is the actual hint content. Intended as a temporary home before this
// pattern migrates into the shared design system — the API mirrors ADS `Tooltip` so a future
// swap is a rename.
//
// When `title` is empty the label renders without underline or tooltip wrapper, so a component
// can conditionally attach hint behavior without a branch at the callsite.
export const Hint = ({ children, className, dataTestId, title }: HintProps) => {
  const composedClassName = [className, title ? styles.underline : undefined]
    .filter(Boolean)
    .join(' ');

  const label = (
    <span className={composedClassName || undefined} data-testid={dataTestId}>
      {children}
    </span>
  );

  if (!title) return label;

  return <Tooltip title={title}>{label}</Tooltip>;
};
